<template>
  <div class="user-manage-box outer-page-primary">
    <div class="header-box">
      <div class="title-box">
        <div class="symbol" />
        <div class="title">用户列表</div>
      </div>
    </div>
    <div class="operation-box common-button-box btn-group-primary">
      <div class="operation-box-top">
        <el-button
          class="primary-btn gr8"
          v-if="isChecked('User.Create')"
          type="primary"
          size="small"
          @click="openUserDialog">
          新增用户
        </el-button>
        <el-button
          class="normal-btn gr8"
          v-if="isChecked('User.UpdateRole')"
          size="small"
          @click="openAssignRoleDialog()">
          分配角色
        </el-button>
        <el-button
          class="normal-btn gr8"
          v-if="isChecked('User.Delete')"
          size="small"
          @click="batchDelUser">
          删除用户
        </el-button>
        <el-button
          class="normal-btn gr8"
          v-if="isChecked('User.ChangePassword')"
          size="small"
          @click="resetPassword">
          重置密码
        </el-button>
      </div>

      <div class="common-input-box">
        <el-input
          class="input-primary userSearch"
          size="small"
          placeholder="请输入搜索内容"
          v-model="filter"
          clearable
          @clear="searchUser"
          @keyup.enter.native="searchUser">
          <div
            class="common-select-box"
            slot="prepend">
            <el-select
              class="prepend-select primary-select"
              :popper-append-to-body="false"
              v-model="searchType">
              <el-option
                label="账号"
                value="surname" />
              <el-option
                label="姓名"
                value="user" />
              <el-option
                label="手机号"
                value="phone" />
              <el-option
                label="角色"
                value="role" />
            </el-select>
          </div>
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="searchUser" />
        </el-input>
      </div>
    </div>
    <div class="user-list-box table-wrapper">
      <div class="common-table-box">
        <el-table
          :header-row-class-name="customHeader"
          highlight-selection-row
          :data="userList"
          height="100%"
          class="publish-table"
          @select="selectChange"
          @select-all="selectChange"
          ref="groupTable">
          <el-table-column
            type="selection"
            width="60" />
          <el-table-column
            label="序号"
            type="index"
            width="55" />
          <el-table-column
            label="用户名"
            prop="surname" />
          <el-table-column
            label="手机号"
            prop="phoneNumber" />
          <el-table-column label="邮箱">
            <template #default="{ row }">{{ row?.email || '--' }}</template>
          </el-table-column>
          <el-table-column label="姓名">
            <template #default="{ row }">
              {{ row?.name || '--' }}
            </template>
          </el-table-column>
          <el-table-column label="公司">
            <template #default="{ row }">
              {{ row?.company || '--' }}
            </template>
          </el-table-column>
          <el-table-column label="企业类型">
            <template #default="{ row }">
              {{ row?.enterpriseType || '--' }}
            </template>
          </el-table-column>
          <el-table-column label="职位">
            <template #default="{ row }">
              {{ row?.position || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            label="角色"
            prop="roleName" />
          <el-table-column
            label="操作"
            width="240">
            <template v-slot="{ row }">
              <div class="common-button-box operation-cell">
                <el-button
                  v-if="isChecked('User.UpdateRole')"
                  @click="openAssignRoleDialog(row)"
                  type="text"
                  size="small">
                  分配角色
                </el-button>
                <el-button
                  v-if="isChecked('User.Update')"
                  @click="editUser(row)"
                  type="text"
                  size="small">
                  编辑用户
                </el-button>
                <el-button
                  v-if="isChecked('User.Delete')"
                  type="text"
                  size="small"
                  @click="deleteUser(row)">
                  删除用户
                </el-button>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="empty-box">
              <!-- <el-empty
                :image="require('@/assets/img/no-data.png')"
                class="empty-page">
                <div class="common-button-box">
                  <el-button
                    class="primary-btn"
                    v-if="isChecked('User.Create')"
                    type="primary"
                    size="small"
                    @click="openUserDialog">
                    新增用户
                  </el-button>
                </div>
              </el-empty> -->
              <bj-empty>
                <template>
                  <div class="common-button-box">
                    <el-button
                      class="primary-btn"
                      v-if="isChecked('User.Create')"
                      type="primary"
                      size="small"
                      @click="openUserDialog">
                      新增用户
                    </el-button>
                  </div>
                </template>
              </bj-empty>
            </div>
          </template>
        </el-table>
      </div>
      <div class="common-pagination-box">
        <el-pagination
          class="pagination-primary"
          popper-class="common-pagination-popper-box"
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100, 150, 200]"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="total"
          @size-change="sizeChange"
          @current-change="pageChange" />
      </div>
    </div>

    <CreateUserDialog
      :visible="userDialogVisible"
      :status="userManageStatus"
      :userInfo="userInfo"
      :closeDialog="closeUserDialog"
      :queryUserList="queryUserList" />
    <AssignRoleDialog
      :visible="assignRoleDialogVisible"
      :selectUsers="usersToAssignRole"
      :roleId="selectRoleId"
      :queryUserList="queryUserList"
      :closeDialog="closeAssignRoleDialog" />
    <DragDialog
      title="提示"
      :width="360"
      :visible.sync="isTransferDialogVisible"
      :footerBtn="['cancel', 'submit']"
      :submit="submitTransfer"
      :cancel="closeTransferDialog">
      <div class="proj-transfer-box">
        <div class="msg-box">{{ deleteMsgTip }}</div>
        <div class="user-input-box">
          <div class="label-box">移交给:</div>
          <div class="common-input-box">
            <el-input
              size="small"
              v-model="userFilterInput"
              placeholder="请输入用户名或手机号"
              clearable
              @clear="searchProjOwner"
              @keyup.enter.native="searchProjOwner">
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="searchProjOwner" />
            </el-input>
          </div>
        </div>
        <div class="user-list-box">
          <div
            v-for="(item, index) in newProjOwnerList"
            :key="index"
            class="user-item-box">
            <span>{{ item.surName }}</span>
            <div class="icon-box">
              <i
                class="el-icon-error icon"
                @click="removeUser(item)" />
            </div>
          </div>
        </div>
      </div>
    </DragDialog>
  </div>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'
import CreateUserDialog from './components/CreateUserDialog.vue'
import AssignRoleDialog from './components/AssignRoleDialog.vue'

import { Store } from '@/utils/store'
import {
  getUserList,
  getNewProjManagerService,
  deleteUserCheckTeamService,
  deleteUserCheckProjService,
  batchDeleteUserCheckTeamService,
  batchDeleteUserCheckProjService,
  deleteUserService,
  batchDeleteUserService
} from '@/service/interface'

export default {
  data() {
    return {
      filter: '',
      searchType: 'surname',
      userList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      selectUsers: [],
      userInfo: null,
      usersToAssignRole: [],
      usersToDelete: [],

      userDialogVisible: false,
      userManageStatus: 'create',

      assignRoleDialogVisible: false,
      selectRoleId: '',
      customHeader: '',
      isTransferDialogVisible: false,
      deleteMsgTip: '',
      userFilterInput: '',
      newProjOwnerList: []
    }
  },
  components: {
    DragDialog,
    CreateUserDialog,
    AssignRoleDialog
  },
  created() {
    this.queryUserList()
  },
  mounted() {
    setTimeout(() => {
      const currentBody = this.$refs.groupTable?.bodyWrapper
      currentBody &&
        currentBody.addEventListener('scroll', ev => {
          const scrollTop = ev.target.scrollTop
          this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
        })
    }, 500)
  },
  methods: {
    searchUser() {
      this.currentPage = 1
      this.queryUserList()
    },
    sizeChange(pageSize) {
      this.pageSize = pageSize
      this.currentPage = 1
      this.queryUserList()
    },
    pageChange(currentPage) {
      this.currentPage = currentPage
      this.queryUserList()
    },
    openUserDialog() {
      this.userDialogVisible = true
    },
    openAssignRoleDialog(userInfo) {
      if (userInfo) {
        this.usersToAssignRole = [userInfo]
        this.selectRoleId = userInfo.roleId
        this.assignRoleDialogVisible = true
        return
      }
      if (this.selectUsers.length) {
        this.usersToAssignRole = this.selectUsers.map(item => item)
        this.selectRoleId = this.selectUsers[0].roleId
        this.assignRoleDialogVisible = true
      } else {
        this.$message.warning('请选择用户！！！')
      }
    },
    deleteUser(userInfo) {
      this.deleteUserCheckTeam(userInfo).then(isCheckTeamPass => {
        if (isCheckTeamPass) {
          this.deleteUserCheckProj(userInfo).then(isCheckProjPass => {
            if (isCheckProjPass) {
              this.$confirm('是否确定删除用户？', '提示', {
                confirmButtonText: '确定',
                type: 'warning'
              })
                .then(() => {
                  this.deleteUserRequest(userInfo.userId).then(isSuccess => {
                    if (isSuccess) {
                      this.currentPage = 1
                      this.queryUserList().then(() => {
                        this.$message.success('删除成功！！！')

                        this.usersToDelete = []
                      })
                    }
                  })
                })
                .catch(() => {
                  // this.$message.info('取消删除')
                })
            }
          })
        }
      })
    },
    deleteUserCheckTeam(userInfo) {
      return new Promise(resolve => {
        let params = { userIds: [userInfo.userId] }
        deleteUserCheckTeamService(params).then(result => {
          if (result.status === 200) {
            let isCheckPass = false
            let response = result.data
            if (response.isSuccess) {
              isCheckPass = true
              resolve(isCheckPass)
            } else {
              this.$confirm(response.errMsg, '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'warning'
              }).then(() => {
                this.usersToDelete = []
                resolve(isCheckPass)
              })
            }
          }
        })
      })
    },
    deleteUserCheckProj(userInfo) {
      return new Promise(resolve => {
        let params = { userIds: [userInfo.userId] }
        deleteUserCheckProjService(params).then(result => {
          if (result.status === 200) {
            let isCheckPass = false
            let response = result.data
            if (response.isSuccess) {
              let errMsg = response.errMsg

              if (errMsg.includes('是否确定删除用户')) {
                isCheckPass = true
                resolve(isCheckPass)
              }

              if (errMsg.includes('请选择移交人员')) {
                this.deleteMsgTip = errMsg
                this.usersToDelete.push(userInfo)
                this.openTransferDialog()
                resolve(isCheckPass)
              }

              if (errMsg.includes('是否删除当前用户')) {
                this.$confirm(response.errMsg, '提示', {
                  confirmButtonText: '确定',
                  type: 'warning'
                })
                  .then(() => {
                    this.deleteUserRequest(userInfo.userId).then(isSuccess => {
                      if (isSuccess) {
                        this.currentPage = 1
                        this.queryUserList().then(() => {
                          this.$message.success('删除成功！！！')

                          this.usersToDelete = []
                          resolve(isCheckPass)
                        })
                      }
                    })
                  })
                  .catch(() => {
                    resolve(isCheckPass)
                  })
              }
            } else {
              this.$confirm(response.errMsg, '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'warning'
              }).then(() => {
                this.usersToDelete = []
                resolve(isCheckPass)
              })
            }
          }
        })
      })
    },
    deleteUserRequest(userId, newProjectOwnerId) {
      return new Promise(resolve => {
        let params = { userId, newProjectOwnerId }
        deleteUserService(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              resolve(true)
            } else {
              this.$message.error(response.errMsg)
              resolve(false)
            }
          }
        })
      })
    },
    batchDelUser() {
      if (!this.selectUsers.length) {
        this.$message.warning('请选择用户！！！')
        return
      }

      if (this.selectUsers.length === 1) {
        let userInfo = this.selectUsers[0]
        this.deleteUser(userInfo)
        return
      }

      this.batchDeleteUserCheckTeam().then(isCheckTeamPass => {
        if (isCheckTeamPass) {
          this.batchDeleteUserCheckProj().then(isCheckProjPass => {
            if (isCheckProjPass) {
              this.$confirm('是否确定删除用户？', '提示', {
                confirmButtonText: '确定',
                type: 'warning'
              })
                .then(() => {
                  this.batchDeleteUserRequest().then(isSuccess => {
                    if (isSuccess) {
                      this.currentPage = 1
                      this.queryUserList().then(() => {
                        this.$message.success('删除成功！！！')

                        this.usersToDelete = []
                      })
                    }
                  })
                })
                .catch(() => {
                  // this.$message.info('取消删除')
                })
            }
          })
        }
      })
    },
    batchDeleteUserCheckTeam() {
      return new Promise(resolve => {
        this.usersToDelete = this.selectUsers.map(item => item)
        let userIds = this.usersToDelete.map(el => el.userId)
        let params = { userIds }
        batchDeleteUserCheckTeamService(params).then(result => {
          if (result.status === 200) {
            let isCheckPass = false
            let response = result.data
            if (response.isSuccess) {
              let data = response.data
              this.usersToDelete = this.selectUsers.filter(el =>
                data.includes(el.userId)
              )

              let errMsg = response.errMsg
              if (!errMsg) {
                isCheckPass = true
                resolve(isCheckPass)
              }

              if (errMsg.includes('是否跳过这些账户')) {
                this.$confirm(response.errMsg, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                })
                  .then(() => {
                    isCheckPass = true
                    resolve(isCheckPass)
                  })
                  .catch(() => {
                    // this.$message.info('取消删除')
                    this.usersToDelete = []
                    resolve(isCheckPass)
                  })
              }
            } else {
              this.$confirm(response.errMsg, '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'warning'
              }).then(() => {
                this.usersToDelete = []
                resolve(isCheckPass)
              })
            }
          }
        })
      })
    },
    batchDeleteUserCheckProj() {
      return new Promise(resolve => {
        let userIds = this.usersToDelete.map(el => el.userId)
        let params = { userIds }
        batchDeleteUserCheckProjService(params).then(result => {
          if (result.status === 200) {
            let isCheckPass = false
            let response = result.data
            if (response.isSuccess) {
              let data = response.data
              this.usersToDelete = this.selectUsers.filter(el =>
                data.includes(el.userId)
              )

              let errMsg = response.errMsg
              if (!errMsg) {
                isCheckPass = true
                resolve(isCheckPass)
                return
              }

              if (errMsg.includes('是否跳过这些用户')) {
                this.$confirm(response.errMsg, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                })
                  .then(() => {
                    this.batchDeleteUserRequest().then(isSuccess => {
                      if (isSuccess) {
                        this.currentPage = 1
                        this.queryUserList().then(() => {
                          this.$message.success('删除成功！！！')

                          this.usersToDelete = []
                          resolve(isCheckPass)
                        })
                      }
                    })
                  })
                  .catch(() => {
                    // this.$message.info('取消删除')
                    this.usersToDelete = []
                    resolve(isCheckPass)
                  })
                return
              }

              if (errMsg.includes('是否确定删除用户')) {
                isCheckPass = true
                resolve(isCheckPass)
              }
            } else {
              this.$confirm(response.errMsg, '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'warning'
              }).then(() => {
                this.usersToDelete = []
                resolve(isCheckPass)
              })
            }
          }
        })
      })
    },
    batchDeleteUserRequest() {
      return new Promise(resolve => {
        let userIds = this.usersToDelete.map(el => el.userId)
        let params = { userIds }
        batchDeleteUserService(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              resolve(true)
            } else {
              this.$message.error(response.errMsg)
              resolve(false)
            }
          }
        })
      })
    },
    openTransferDialog() {
      this.isTransferDialogVisible = true
    },
    searchProjOwner() {
      if (!this.userFilterInput) {
        this.$message.warning('请输入用户名或手机号')
        return
      }
      let params = {
        input: this.userFilterInput
      }
      getNewProjManagerService(params).then(response => {
        if (response.isSuccess) {
          let surnameData = response.data
          this.handleSearchResult(surnameData)
        } else {
          this.$message.error('用户不存在，请重新输入！！！')
          this.userFilterInput = ''
        }
      })
    },
    removeUser(userInfo) {
      let findIndex = this.newProjOwnerList.findIndex(
        el => el.id === userInfo.id
      )
      this.newProjOwnerList.splice(findIndex, 1)
      this.userFilterInput = ''
    },
    handleSearchResult(data) {
      let find = this.newProjOwnerList.find(el => el.id === data.userId)
      if (!find) {
        this.newProjOwnerList = []
        let userInfo = {
          id: data.userId,
          surName: data.surName ? data.surName : data.userName
        }
        this.newProjOwnerList.push(userInfo)
      } else {
        this.$message.error('已选择该用户，请重新输入！！！')
        this.userFilterInput = ''
      }
    },
    submitTransfer() {
      if (!this.newProjOwnerList.length) {
        this.$message.warning('请先指定项目移交人员')
        return
      }

      let userId = this.usersToDelete[0].userId
      let newProjectOwnerId = this.newProjOwnerList[0].id
      this.deleteUserRequest(userId, newProjectOwnerId).then(isSuccess => {
        if (isSuccess) {
          this.currentPage = 1
          this.queryUserList().then(() => {
            this.$message.success('删除成功！！！')

            this.usersToDelete = []
            this.closeTransferDialog()
          })
        } else {
          this.closeTransferDialog()
        }
      })
    },
    closeTransferDialog() {
      this.usersToDelete = []
      this.deleteMsgTip = ''
      this.userFilterInput = ''
      this.newProjOwnerList = []
      this.isTransferDialogVisible = false
    },
    resetPassword() {
      if (!this.selectUsers.length) {
        this.$message.warning('请选择需要重置密码的用户！！！')
        return
      }
      if (this.selectUsers.length > 1) {
        this.$message.warning('每次只允许重置一个用户的密码！！！')
        return
      }
      this.userInfo = this.selectUsers[0]
      this.userManageStatus = 'resetPassword'
      this.userDialogVisible = true
    },
    selectChange(selection) {
      this.selectUsers = selection
    },
    setAllExpand(state) {
      let nodes = this.$refs.tree.store._getAllNodes()
      for (let i in nodes) {
        nodes[i].expanded = state
      }
    },
    editUser(userInfo) {
      this.userInfo = userInfo
      this.userManageStatus = 'edit'
      this.userDialogVisible = true
    },
    closeUserDialog() {
      this.userInfo = null
      this.userManageStatus = 'create'
      this.userDialogVisible = false
    },
    closeAssignRoleDialog() {
      this.usersToAssignRole = []
      this.selectRoleId = ''
      this.assignRoleDialogVisible = false
    },
    queryUserList() {
      return new Promise(resolve => {
        let params = {
          maxResultCount: this.pageSize,
          skipCount: (this.currentPage - 1) * this.pageSize,
          sorting: '',
          searchType: this.searchType,
          filter: this.filter
        }
        getUserList(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              let data = response.data
              this.userList = data.items
              this.total = data.totalCount
              resolve()
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less">
@import '@/assets/css/pageStyle.less';
@import '@/assets/css/publishSearch.less';
.user-manage-box {
  height: 100%;

  .header-box {
    display: flex;
    justify-content: space-between;
    text-align: left;

    .title-box {
      display: flex;
      align-items: center;

      .symbol {
        width: 4px;
        height: 20px;
        background: var(--base-primary-bgColor);
      }

      .title {
        margin-left: 10px;
        color: var(--page-title-color);
      }
    }
  }

  .operation-box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .common-input-box {
      .common-select-box {
        min-width: 40px;
        text-align: left;

        .el-select {
          .is-focus {
            .el-input__inner {
              border: none !important;
            }
          }
        }

        .el-select-dropdown {
          min-width: 120px !important;
        }

        .el-input__inner {
          box-shadow: none;
          border-right: none;
          height: 32px;
          line-height: 32px;
          &:hover {
            border: none !important;
            box-shadow: none;
          }

          &:focus {
            border: none !important;
            box-shadow: none;
          }
        }
      }

      .userSearch {
        &:hover {
          border-radius: 8px;
          border: none;
        }

        &:focus {
          box-shadow: none;
          border: none;
        }

        .el-input-group__prepend {
          border-color: var(--userManage-input-border-color);
          border-right: 1px solid var(--userManage-input-border-color);

          &:has(.is-focus) {
            border-color: var(--userManage-input-pre-focus-border-color);

            .is-focus {
              .el-input__icon {
                color: var(--base-primary-bgColor);
              }
            }
          }
        }

        > .el-input__inner {
          border-color: var(--userManage-input-border-color);
          &:hover {
            border: 1px solid var(--userManage-input-border-color) !important;
            border-left: none !important;
          }

          &:focus {
            border: 1px solid var(--userManage-input-border-color) !important;
            border-left: none !important;
            box-shadow: none;
          }
        }
      }
    }
  }

  .user-list-box {
    height: calc(100% - 111px);

    .common-table-box {
      height: calc(100% - 64px);
    }
  }

  .el-dialog__wrapper {
    top: 180px;
    .el-dialog {
      background: #383838;
      text-align: left;

      .el-dialog__title {
        color: #ffffff;
      }

      .el-dialog__body {
        padding: 15px 20px;
        color: #ffffff;
      }
    }
  }

  .message-box {
    display: flex;
    margin-bottom: 10px;

    .icon {
      color: #ec9d00;
      margin-right: 5px;
    }
  }

  .dom-box {
    margin-left: 20px;

    .el-checkbox {
      color: #ffffff;
    }
  }
}

.proj-transfer-box {
  color: var(--default-color);

  .msg-box {
    font-size: 14px;
  }

  .user-input-box {
    display: flex;
    align-items: center;
    margin-top: 10px;

    .common-input-box {
      flex-grow: 1;
      margin-left: 5px;
    }
  }

  .user-list-box {
    margin: 10px 0px 0px 55px;
    .user-item-box {
      display: inline-flex;
      align-items: center;
      border-radius: 20px;
      padding: 2px 10px;
      border: 1px solid #919ac6;

      .icon-box {
        font-size: 14px;
        margin-left: 5px;
        color: #d9d9d9;
        cursor: pointer;
      }
    }
  }
}
</style>
